import React from 'react'
import Style from './index.style'

const CardVendor = ({ image, title, styleImg = {}, styleImage = {} }) => {
  return (
    <Style className="card-vendor">
      <div style={{ ...styleImage }} className="image">
        <img style={{ ...styleImg }} src={image} alt="halojasa/vendor" />
      </div>
      <div className="title">{title}</div>
    </Style>
  )
}

export default CardVendor
